import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { ServiceProductService } from '../services/service-product.service';
import { AddServiceProductComponent } from './add-service-product/add-service-product.component';
import { EditServiceProductComponent } from './edit-service-product/edit-service-product.component';
import { ImportServiceProductComponent } from './import-service-product/import-service-product.component';

@Component({
  selector: 'app-service-product',
  templateUrl: './service-product.component.html',
  styleUrls: ['./service-product.component.css']
})
export class ServiceProductComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: AddServiceProductComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditServiceProductComponent;
  @ViewChild('pImport', { static: false }) pImport: ImportServiceProductComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: ServiceProductService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'serviceProductCode',
        header: 'Mã dịch vụ sản phẩm',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'serviceProductName',
        header: 'Tên dịch vụ sản phẩm',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'businessSectorName',
        header: 'Lĩnh vực',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'serviceProductGroupName',
        header: 'Nhóm sản phẩm',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };

    this._service
      .getListServiceProduct(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editServiceProduct(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteServiceProduct(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động dịch vụ sản phẩm này')
        .then((res) => {
          if (res) {
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
    this.pCreate.showPopup();
  }

  onImport() {
    this.pImport.showPopup();
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
